import axios from "axios";
import { CELERY_PROGRESS_STATUS, CELERY_PROGRESS_STATUS_OBJECT, ORDER_TYPE, SALE_TYPE, NotAssigned } from "../../../Common/constants";
import {
  PRODUCTS_URL,
  COUPONS_URL,
  ORDER_URL,
  CUSTOMERS_URL,
  ORDER_RETURN_URL,
  SO_MAIL_INVOICE,
  GET_STATE_URL,
  GET_CITY_URL,
  CALC_ORDER_URL,
  LAST3SO,
  PREV_PROD_SOLD_PRICE,
  PRESIGNED_URL,
  CUSTOMER_LEDGER_STATS,
  CUSTOMER_LEDGER_SUMMARY_REGENERATE,
  CUSTOMER_LEDGER_SIMPLIFIED_REGENERATE,
  SUPPLIER_PURCHASE_HISTORY_URL,
  SUPPLIER_PURCHASE_RETURN_HISTORY_URL,
  SUPPLIER_LEGDER_URL,
  SUPPLIER_LEDGER_SIMPLIFIED_REGENERATE,
  SUPPLIER_LEDGER_EMAIL_URL,
  ACTIVITY_LOGS_URL,
  CUST_ACH_ONBOARD_PUBLIC_URL,
  PickingList_URL,
  GENERATE_EDI_URL,
  USER_URL,
  BOX_MGMT_URL,
} from "../../../../../constants/config";
import { initialFilter } from "../../pages/customer/list-page/ui-helpers";
import { notification } from "antd";
import { useEffect, useState } from "react";
import { checkBackgroundTaskStatus } from "../../../Common/backgroundTaskStatus";

const encodeQueryValue = (value) => encodeURIComponent(value ?? "");

const formatTagValuesParam = (tagValues) => {
  if (!tagValues) {
    return "";
  }

  if (Array.isArray(tagValues)) {
    return tagValues.map((value) => encodeQueryValue(value)).join(",");
  }

  return encodeQueryValue(tagValues);
};

export function findProducts(queryParams) {
  return axios.get(
    `${PRODUCTS_URL}/list3?channel_id=${queryParams.channel_id || "1"}&page_size=${queryParams?.pageSize ? queryParams?.pageSize : 200}&search_key=${
      queryParams?.searchKey ? encodeURIComponent(queryParams?.searchKey.trimLeft()) : ""
    }&product_ids=${queryParams?.productIds || ""}&sort_by=name&sort_in=asc&tobacco_status=1&scan_mode=${queryParams?.withScanner || 0}&show_stocks=${queryParams?.show_stocks ?? 0}&is_archived=0&customer_id=${queryParams?.customer_id || queryParams?.price_customer_id || ""}${
      queryParams?.price_customer_id ? `&price_customer_id=${queryParams.price_customer_id}` : ""
    }${queryParams?.force_preserve_price_off ? `&force_preserve_price_off=${queryParams.force_preserve_price_off}` : ""}`
  );
}

export function findOptimizedProductsForSale(queryParams) {
  return axios.get(
    `${PRODUCTS_URL}/list3?channel_id=${queryParams.channel_id || "1"}&page=${queryParams?.page || 1}&page_size=${queryParams?.pageSize ? queryParams?.pageSize : queryParams.page_size || 200}&show_stocks=${queryParams?.show_stocks ?? 1}&search_key=${
      queryParams?.searchKey
        ? encodeURIComponent(queryParams?.searchKey.trimLeft())
        : queryParams?.search_key
          ? encodeURIComponent(queryParams?.search_key.trimLeft())
          : ""
    }&category_ids=${queryParams.categories ? queryParams.categories : queryParams.category_ids || ""}&brand_ids=${queryParams.brands ? queryParams.brands : queryParams.brand_ids || ""}&product_ids=${queryParams?.productIds || ""}&sort_by=name&sort_in=asc&tobacco_status=1&scan_mode=${
      queryParams?.withScanner || 0
    }&is_archived=0&customer_id=${queryParams?.customer_id || queryParams?.price_customer_id || ""}${
      queryParams?.price_customer_id
        ? `&price_customer_id=${queryParams.price_customer_id}`
        : queryParams?.price_customer_id === ""
          ? `&price_customer_id=${""}`
          : ""
    }${queryParams?.force_preserve_price_off ? `&force_preserve_price_off=${queryParams.force_preserve_price_off}` : ""}${queryParams?.taxable_state ? `&taxable_state=${queryParams.taxable_state}` : ""}${queryParams?.taxable_county ? `&taxable_county=${queryParams.taxable_county}` : ""}${queryParams?.taxable_city ? `&taxable_city=${queryParams.taxable_city}` : ""}${queryParams?.get_taxes ? `&get_taxes=${queryParams.get_taxes}` : ""}${queryParams?.include_unit_prices == 0 || queryParams?.include_unit_prices ? `&include_unit_prices=${queryParams?.include_unit_prices}` : ""}`
  );
}
export function scanOrderDetail(queryParams) {
  return axios.get(`${ORDER_URL}/${queryParams.orderId}/search_sods?search_key=${queryParams.searchText}&page_size=${queryParams.pageSize}`);
}
export function createOrder(order) {
  return axios.post(`${ORDER_URL}`, order);
}
export function sendEmail(email) {
  return axios.post(`${SO_MAIL_INVOICE}`, email);
}
export function addPayment(payment) {
  return axios.post(`${ORDER_URL}/payment`, payment);
}
export function getCreditCheck(customerId) {
  return axios.get(`${ORDER_URL}/credit-check?customer_id=${customerId}`);
}
export function updateOrder(orderId, order) {
  return axios.put(`${ORDER_URL}/${orderId}/edit`, order);
}
export function postfortag(Id, param) {
  return axios.post(`${ORDER_URL}/${Id}/tags`, param);
}
export function applyCoupon(queryParams) {
  return axios.get(`${COUPONS_URL}/${queryParams.coupon}/${queryParams.userId}`);
}
export function saveInvoiceSetting(order) {
  return axios.patch(`${ORDER_URL}/${order.orderId}/invoice-setting`, order.payload);
}

//orders list start
export function findSaleOrder(queryParams) {
  const sortField = queryParams?.sortBy || queryParams?.sortField || "updated_at";
  const sortOrder = queryParams?.sortOrder === "asc" || queryParams?.sortOrder === "ascend" ? "asc" : "desc";
  const sortBy = queryParams?.sort_by || `${sortField}:${sortOrder}`;

  return axios.get(
    `${ORDER_URL}/list2?search_key=${queryParams?.searchKey || ""}&only_guest=${
      queryParams?.guest !== undefined ? queryParams.guest : 0
    }&page=${queryParams?.pageNumber || 1}&page_size=${queryParams?.pageSize || 20}&statuses=${queryParams?.statuses || ""}&customerIds=${
      queryParams?.customerId || ""
    }&sale_agents=${queryParams?.sale_agents || ""}&startDate=${queryParams.startDate ? queryParams.startDate : ""}&endDate=${
      queryParams.endDate ? queryParams.endDate : ""
    }&order_date_start=${queryParams?.startDate ? queryParams?.startDate : ""}&order_date_end=${queryParams?.endDate || ""}&product_ids=${
      queryParams?.product_ids ? queryParams?.product_ids : []
    }&orderNo=${queryParams?.orderNo || queryParams?.order || ""}&sort_by=${sortBy}&sale_type=${queryParams?.sale_type || 1}&invoice_statuses=${
      queryParams?.invoice_statuses || ""
    }&exclude_statuses=${queryParams?.exclude_statuses || ""}&shippingType=${queryParams?.shippingType || ""}&invoice_status_previous=${queryParams?.invoice_status_previous || ""
    }&channel_ids=${queryParams?.channel_ids || ""}&tag_values=${formatTagValuesParam(queryParams?.tag_values)}&business_name=${queryParams?.business_name || ""
    }&business_address=${queryParams?.business_address || ""}&business_phone_no=${queryParams?.business_phone_no || ""}&product=${queryParams?.product || ""
    }&sku=${queryParams?.sku || ""}&upc=${queryParams?.upc || ""}&order_type=${queryParams?.order_type || ""}&created_by_ids=${queryParams?.created_by_ids || ""
    }&delivery_fulfilment_statuses=${queryParams?.delivery_fulfilment_statuses || ""}&prefer_driver_ids=${queryParams?.prefer_driver_ids || ""}`
  );
}

export function optimzedSaleOrderRequest(params) {
  return axios.get(`${ORDER_URL}/list2`, { params });
}

// Supplier Purchase Order History list
export function getSupplierPurchaseOrderHistoryList(params) {
  return axios.get(`${SUPPLIER_PURCHASE_HISTORY_URL}`, { params });
}

// Supplier Purchase Return History
export function getSupplierPurchaseReturnHistoryList(params) {
  return axios.get(`${SUPPLIER_PURCHASE_RETURN_HISTORY_URL}`, { params });
}

export function getSupplierLedgerList(payload) {
  return axios.post(`${SUPPLIER_LEGDER_URL}`, payload);
}

export function regenerateSimplifiedSupplierLedger(supplier_id, hardRefresh = false) {
  return axios.post(`${SUPPLIER_LEDGER_SIMPLIFIED_REGENERATE}`, { supplier_id, hard_refresh: hardRefresh });
}

//fulfillment list start
export function findSaleFulfillment(queryParamss) {
  let queryParams = queryParamss != undefined ? queryParamss : initialFilter;
  // Only honor an explicit `sortBy` (set deliberately by the fulfillment listing's ui-context).
  // Deliberately NOT falling back to `queryParams.sortField`, since other callers of this
  // function (e.g. saleQOrder/saleOrder fulfillment lists) spread the generic `initialFilter`
  // (sortField: "updated_at") without intending to control this endpoint's sort.
  const sortField = queryParams?.sortBy || "created_at";
  const sortOrder = queryParams?.sortOrder === "asc" || queryParams?.sortOrder === "ascend" ? "asc" : "desc";
  const sortBy = queryParams?.sort_by || `${sortField}:${sortOrder}`;

  return axios.get(
    `${ORDER_URL}/list2?search_key=${queryParams.searchKey || ""}` +
      `&page=${queryParams.pageNumber || 1}` +
      `&page_size=${queryParams.pageSize || 20}` +
      `&statuses=${queryParams.statuses || "10,21,22,23,26,30,35,15"}` +
      `&order_type=${queryParams.orders !== undefined && queryParams.orders !== null ? queryParams.orders : Object.keys(ORDER_TYPE).map((order) => ORDER_TYPE[order].value)}` +
      `&customerIds=${queryParams.customerId !== undefined && queryParams.customerId !== null ? queryParams.customerId : ""}` +
      `&order_date_start=${queryParams.startDate || ""}` +
      `&order_date_end=${queryParams.endDate || ""}` +
      `&payment_types=${queryParams.payments !== undefined && queryParams.payments !== null ? queryParams.payments : ""}` +
      `&orderNo=${queryParams.orderNo || ""}` +
      `&shippingType=${queryParams.shippingType || ""}` +
      `&order_date_start=${queryParams.orderDateStart || ""}` +
      `&channel_ids=${queryParams.channel_ids || ""}` +
      `&order_date_end=${queryParams.orderDateEnd || ""}` +
      `&pickup_delivery_date_start=${queryParams.pickupDeliveryDateStart || ""}` +
      `&pickup_delivery_date_end=${queryParams.pickupDeliveryDateEnd || ""}` +
      `&sort_by=${sortBy}` +
      `&sale_type=${queryParams.sale_type || 1}` +
      `&sale_reps=${queryParams.sale_reps || ""}` +
      `&tag_values=${formatTagValuesParam(queryParams.tag_values)}` +
      `&order_picker_ids=${queryParams.order_picker_ids || ""}` +
      `&state=${queryParams.state || ""}` +
      `&city=${queryParams.city || ""}` +
      `&county=${queryParams.county || ""}` +
      `&zip_code=${queryParams.zip_code || ""}` +
      `&invoice_statuses=${queryParams.invoice_statuses || ""}` +
      `&exported_pick_list=${queryParams.exported_pick_list ?? ""}` +
      `&prefer_driver_ids=${queryParams.prefer_driver || ""}` +
      `&created_by_ids=${queryParams.created_by_ids || ""}` +
      `&delivery_fulfilment_statuses=${queryParams.delivery_fulfilment_statuses || ""}`
  );
}

export function getCustomerLedgerStats(payload) {
  return axios.post(`${CUSTOMER_LEDGER_STATS}`, payload);
}

export function regenerateCustomerLedgerSummary(customer_id, hardRefresh = false) {
  return axios.post(`${CUSTOMER_LEDGER_SUMMARY_REGENERATE}`, { customer_id, hard_refresh: hardRefresh });
}

export function regenerateSimplifiedCustomerLedger(customer_id, hardRefresh = false) {
  return axios.post(`${CUSTOMER_LEDGER_SIMPLIFIED_REGENERATE}`, { customer_id, hard_refresh: hardRefresh });
}

export function saveTrackingDetails(queryParams) {
  return axios.post(`${ORDER_URL}/${queryParams.order.id}/so-shipment-tracking`, queryParams.shippingDetails);
}

export function getSaleOrderByIdOptimized(id) {
  return axios.get(`${ORDER_URL}/v2/${id}`);
}

export function getOrderTrackingList(id) {
  return axios.get(`${ORDER_URL}/so-shipment-tracking/list?sale_order_id=${id}`);
}

export function getTrackingDetailsById(id) {
  return axios.get(`${ORDER_URL}/${id}/so-tracking-detail`);
}

export function updateOrderTrackingDetails(id, orderTracking) {
  return axios.patch(`${ORDER_URL}/${id}/so-shipment-tracking`, orderTracking);
}

export function getSaleOrderById(id) {
  return axios.get(`${ORDER_URL}/${id}?edit=1&include_main_category=1&include_transferable_qty=1&include_unit_prices=1`);
}

export function getSaleOrderForCopyById(id) {
  return axios.get(`${ORDER_URL}/${id}/copy?edit=1&include_main_category=1&include_transferable_qty=1&include_unit_prices=1`);
}
export function getSaleOrderByNo(no, publicKey) {
  return axios.get(`${ORDER_URL}/${no}?public_key=${publicKey || ""}&include_main_category=1&include_transferable_qty=1`);
}

export function markSaleOrderAsDownloaded(id) {
  return axios.post(`${ORDER_URL}/${id}/picklist/mark-downloaded`);
}

export function getPaymentHistoryById(id) {
  return axios.get(`${ORDER_URL}/${id}?edit=1&include_main_category=1`);
}

export function createOrderReturn(order, return_edit) {
  if (!!return_edit) {
    return axios.put(`${ORDER_RETURN_URL}/${return_edit}`, order);
  } else {
    return axios.post(`${ORDER_RETURN_URL}`, order);
  }
}

export function CalcCartTotal(order) {
  try {
    return axios.post(`${CALC_ORDER_URL}`, order);
  } catch (e) {
    console.log(e);
  }
}

export function prevProSoldPrice(order) {
  try {
    return axios.post(`${PREV_PROD_SOLD_PRICE}`, order);
  } catch (e) {
    console.log(e);
  }
}

export function lastThreeSO(id, customer_id) {
  return axios.get(`${LAST3SO}?product_id=${id}&customer_id=${customer_id || ""}`);
}

export function assignUser(orderId, userId) {
  try {
    if (userId === NotAssigned) {
      return axios.post(`${ORDER_URL}/${orderId}/unassign-picker`, {});
    } else {
      return axios.post(`${ORDER_URL}/${orderId}/assign-picker`, { user_id: userId });
    }
  } catch (e) {
    console.error(e);
  }
}

// Backend now exposes this as a bulk-only endpoint (POST /assign-preferred-driver with
// {sale_order_ids, driver_id} — no sale_order_id in the URL anymore). `saleOrderIds` accepts
// either a single id (existing per-row call sites) or an array (new bulk selection),
// normalized here so callers don't all need to remember to wrap a single id in an array.
export function assignPreferredDriver(saleOrderIds, driverId) {
  return axios.post(`${ORDER_URL}/assign-preferred-driver`, {
    sale_order_ids: Array.isArray(saleOrderIds) ? saleOrderIds : [saleOrderIds],
    driver_id: driverId,
  });
}

export function completePickingPartiallyFulfilled(id) {
  return axios.post(`${ORDER_URL}/${id}/complete-non-fulfilled`);
}

export function getSaleOrderToCopy(id) {
  return axios.get(`${ORDER_URL}/${id}/copy`);
}

export function postInvoice({ orderId, payload }) {
  const url = `${ORDER_URL}/${orderId}?skip_scan=0`;
  return axios.patch(url, payload);
}

// on sale order id base we change the status of the sale order
export function changeOrderStatus(queryParams) {
  let include_executed_products = queryParams?.include_executed_products;
  let execute_all = queryParams?.execute_all;

  return axios.patch(
    `${ORDER_URL}/${queryParams.order.id}`,
    {
      status: parseInt(queryParams.status),
      include_executed_products,
      execute_all,
    },
    {
      params: {
        skip_scan: queryParams?.skip_scan || 0,
      },
    }
  );
}

export function patchRequestForSaleOrder(payload) {
  let { id, ...rest } = payload;
  return axios.patch(`${ORDER_URL}/${id}`, { ...rest });
}

export function optimizedChangeOrderStatus({ id, status }) {
  return axios.patch(`${ORDER_URL}/${id}`, {
    status: parseInt(status),
  });
}

export function bulkExecuteSaleOrder(orderIds, options = {}) {
  return axios.patch(`${ORDER_URL}/bulk_execute`, { sale_order_ids: orderIds, execute_all: options.execute_all ?? true });
}

export function bulkCompletePickingSaleOrder(orderIds, removeUnpicked) {
  return axios.patch(`${ORDER_URL}/bulk_complete_picking`, { sale_order_ids: orderIds, remove_unpicked: removeUnpicked });
}

export function executeSaleOrderDirectly(infoForExecute) {
  return axios.patch(`${ORDER_URL}/${infoForExecute.id}/execute`, { ...infoForExecute });
}

export function emailForPayemnt({ id }) {
  return axios.post(`${ORDER_URL}/${id}/payment-request-email`);
}

export function requestEmailPreview({ id }) {
  return axios.get(`${ORDER_URL}/${id}/payment-request-email`);
}

export function getSaleOrderForPicking(orderId) {
  return axios.get(`${ORDER_URL}/${orderId}/fulfilments`);
}

export function parkOrderPicking(queryParams) {
  return axios.patch(`${ORDER_URL}/${queryParams.order.id}/pick`, queryParams.payload, {
    params: { is_save: queryParams?.is_save || 0 },
  });
}

// cancel Pausing/Cancel Packing used to cancel the packing of sale order and sale order status will return to cancel pausing
export function cancelPausing(queryParams) {
  return axios.patch(`${ORDER_URL}/${queryParams.order.id}/cancel-packing`);
}

// sale order packed
export function parkOrderPacking(queryParams) {
  return axios.patch(`${ORDER_URL}/${queryParams.order.id}/pack`, queryParams.payload, {
    params: { change_status: queryParams?.change_status || "" },
  });
}
export function findOrderByNo(queryParams) {
  return axios.get(`${ORDER_URL}/list2`, { params: { ...queryParams, sale_type: SALE_TYPE.SALE_ORDER.value } });
}

export function deleteOrder(id) {
  return axios.delete(`${ORDER_URL}/${id}`);
}

export function bulkDeleteOrders(ids) {
  return axios.delete(`${ORDER_URL}/bulk`, {data: ids.map(id => ({id}))});
}

export function switchOrderCustomer(orderId, customerId) {
  return axios.patch(`${ORDER_URL}/${orderId}/switch/${customerId}`);
}

//search customer to create order
export function searchCustomers(queryParams) {
  let search_name_business_name = queryParams?.searchbyNameBusinessName?.trimLeft();
  let search_number_id = queryParams?.searchbyIdNumber?.trimLeft();
  let search_email_address_phone = queryParams?.searchbyEmailAddressPhone?.trimLeft();
  let is_active = queryParams?.isActive || -1;
  return axios.get(`${CUSTOMERS_URL}/list2`, {
    params: {
      search_name_business_name,
      search_number_id,
      search_email_address_phone,
      sort_by: queryParams.sort_by || "name:asc",
      is_active,
    },
  });
}

//search customer by name
export function optimzedCustomerSearch(params) {
  return axios.get(`${CUSTOMERS_URL}/list2`, { params });
}

//search customer by name
export function findCustomerByName(queryParams) {
  return axios.get(`${CUSTOMERS_URL}/list2?search_key=${queryParams}`);
}

//search customer by name
export function findProductByName(queryParams) {
  return axios.get(`${PRODUCTS_URL}/list2?search_key=${queryParams}`);
}

export function customerAchFromPublic(queryParams, payload) {
  return axios.patch(`${CUST_ACH_ONBOARD_PUBLIC_URL}/onboard?public_key=${queryParams}`, payload);
}

export function findCustomerById(queryParams) {
  return axios.get(`${CUSTOMERS_URL}/${queryParams}`);
}
//validate shipping detail
export function validateShippingDetail(shippingDetail) {
  return axios.post(`${ORDER_URL}/validate-shipping-detail`, shippingDetail);
}
export function createQuickCustomer(customer) {
  return axios.post(`${CUSTOMERS_URL}`, customer);
}

export function getStates(params) {
  return axios.get(`${GET_STATE_URL}`, { params });
}

export function getCities(params) {
  return axios.get(`${GET_CITY_URL}`, { params });
}

export function getPresignedUrl(key) {
  key = key.replaceAll(" ", "-");
  return axios.post(PRESIGNED_URL, [{ key: key }]);
}

export function uploadFileToCloud(payload) {
  return fetch(payload.url, {
    method: "PUT",
    body: payload.file,
  });
}

export function supplierLeadgerEmail(payload) {
  const { id, ...restPayload } = payload;
  return axios.post(`${SUPPLIER_LEDGER_EMAIL_URL}/${id}`, restPayload);
}

// Get Sale Order Activity Logs
export function saleOrderActivityLogs(queryparams) {
  return axios.get(
    `${ACTIVITY_LOGS_URL}?performed_by=${queryparams?.user_id}&table_name=sale_orders&entity_id=${queryparams?.product_id}&sort_by=created_at:asc`
  );
}

export function skipPackingAndDoExecuteAtOnceRequest({ id, status }) {
  return axios.patch(`${ORDER_URL}/${id}`, {
    status: parseInt(status),
  });
}

export function DownloadPickingList(params, id, publicKey) {
  return axios.post(`${PickingList_URL}/${id}/picklist?public_key=${publicKey}`, params);
}

export function DownloadActivityLog(id) {
  return axios.get(`${PickingList_URL}/${id}/activity`);
}

export function DownloadPackingList(id, publicKey) {
  return axios.get(`${PickingList_URL}/${id}/packlist?public_key=${publicKey}`);
}

export function generateEdiReport(id, publicKey, format) {
  return axios.get(`${GENERATE_EDI_URL}/${id}/generate-edi?public_key=${publicKey}&format=${format || ""}`);
}
export function generateExportExcelReport(id, publicKey) {
  return axios.get(`${GENERATE_EDI_URL}/${id}/excel-export?public_key=${publicKey}`);
}

export function generateExportPDFinvoice(id, publicKey) {
  return axios.get(`${GENERATE_EDI_URL}/${id}/pdf-export?public_key=${publicKey}`);
}

export function checkImportApiStatus(id) {
  return checkBackgroundTaskStatus(id);
}

export const useTaskStatus = (taskIdKey, downloadFileName = "reports.xlsx", notdownloadableCheck, pk) => {
  const [exportStatus, setExportStatus] = useState(null);
  const [downloadUrl, setDownloadUrl] = useState(null);

  const handleBackgroundTask = () => {
    const taskId = localStorage.getItem(taskIdKey);
    if (taskId !== "null") {
      checkImportApiStatus(`${taskId}${pk ? `?public_key=${pk}` : ""}`)
        .then((res) => {
          const { id, result, status: statusKey } = res.data.entity;
          setExportStatus(CELERY_PROGRESS_STATUS[statusKey]?.slug);
          if ([CELERY_PROGRESS_STATUS_OBJECT.COMPLETED.id, CELERY_PROGRESS_STATUS_OBJECT.FAILED.id].includes(statusKey)) {
            if (CELERY_PROGRESS_STATUS_OBJECT.FAILED.id === statusKey) {
              notification.error({ message: "Export Failed" });
            }
            localStorage.setItem(taskIdKey, "null");
            if (statusKey === CELERY_PROGRESS_STATUS_OBJECT.COMPLETED.id && result?.download_url) {
              if (notdownloadableCheck) {
                setDownloadUrl(result.results);
              } else {
                const link = document.createElement("a");
                link.href = result.download_url;
                link.setAttribute("download", downloadFileName);
                document.body.appendChild(link);
                link.click();
                localStorage.setItem(taskIdKey, "null");
                setExportStatus(null);
              }
            }
          } else {
            setTimeout(handleBackgroundTask, 1500);
          }
        })
        .catch((err) => {
          console.error(err);
        });
    }
  };

  useEffect(() => {
    const taskId = localStorage.getItem(taskIdKey);
    if (taskId) {
      handleBackgroundTask();
    }
  }, [taskIdKey]);

  return { exportStatus, handleBackgroundTask, downloadUrl };
};

export const findUsersCustomizedWay = (params) => {
  return axios.get(`${USER_URL}/list`, { params });
};

// Both box list endpoints default to page_size=20 server-side, and no caller here
// paginates them. A truncated list makes the UI believe boxes/items do not exist —
// it then re-adds them and trips the per-order-line pack limit the server still
// counts them against. Request the full set; an explicit page_size still wins.
export const BOX_LIST_PAGE_SIZE = 500;

export function listShipmentBoxes(params) {
  // params: { sale_order_id, is_closed?, is_tracking_present?, page?, page_size? }
  return axios.get(`${BOX_MGMT_URL}/list`, { params: { page_size: BOX_LIST_PAGE_SIZE, ...params } });
}















